import { useCallback, useEffect, useState } from 'react'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { PlusIcon as CreateIcon, PenIcon as EditIcon } from 'lucide-react'

import Modal from 'components/Modal'
import { CreateReport19 } from './reports-form-list/create-report_19'

const REPORTS_OPTIONS = [
  {
    name: 'Report 19',
    link: '?modal=report_19',
    type: 'report_19',
  },
] as const

const getModalOptions = () => {
  return REPORTS_OPTIONS
}

type ReportOptionsTypesType =
  | (typeof REPORTS_OPTIONS)[number]['type']
  | undefined

type ReportOptionType = (typeof REPORTS_OPTIONS)[number] | null

const useCampaignListActionsModal = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams() ?? undefined
  const queryModal =
    (searchParams.get('modal') as ReportOptionsTypesType) ?? undefined
  const [isShowCreateModal, isShowCreateModalSet] = useState(false)
  const [isShowEditModal, isShowEditModalSet] = useState(false)
  const [reportType, reportTypeSet] = useState<ReportOptionType>(null)

  const resetModal = useCallback(() => {
    isShowCreateModalSet(false)
    isShowEditModalSet(false)
    navigate('?modal=null')
  }, [isShowCreateModalSet, isShowEditModalSet, navigate])

  const handleReport = useCallback(
    (queryModal: ReportOptionsTypesType) => {
      const modalOptions = getModalOptions()
      const filtered = modalOptions.filter(
        (item) => item.type === queryModal
      )[0]
      reportTypeSet(filtered)
    },
    [reportTypeSet]
  )

  useEffect(() => {
    if (queryModal === 'report_19') {
      isShowCreateModalSet(true)
      handleReport(queryModal)
    } else {
      resetModal()
    }
  }, [
    queryModal,
    isShowCreateModalSet,
    isShowEditModalSet,
    resetModal,
    handleReport,
  ])

  return {
    isShowCreateModal,
    isShowEditModal,
    resetModal,
    reportType,
  }
}

export const CreateReportsModal = () => {
  const { reportType, isShowCreateModal, resetModal } =
    useCampaignListActionsModal()

  return (
    <>
      <div className="flex flex-col gap-4 w-max">
        {REPORTS_OPTIONS.map((item) => (
          <button
            key={item.name}
            className="px-3 py-1 border rounded-md border-primary text-primary"
            type="button"
          >
            <Link to={item.link} className="flex items-center gap-2">
              <CreateIcon size={16} />
              <span className="tracking-wider font-light">{item.name}</span>
            </Link>
          </button>
        ))}
      </div>

      {reportType && (
        <Modal
          title={reportType.name}
          open={isShowCreateModal}
          onClose={resetModal}
          noFooter
        >
          {/* REPORT 19 */}
          {reportType.type === 'report_19' && (
            <CreateReport19 onCloseModal={resetModal} />
          )}
        </Modal>
      )}
    </>
  )
}
